import React from 'react'
import './App.css';
import { Select, Button } from "@chakra-ui/react"
import TwitterLogo from './twitterLogo.png'
import OSLogo from './osLogo.png'
import axios from 'axios'
import { ethers } from "ethers";
import { Modal } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';

const blockheadData = [
    {
        nameDomain: 'i/austinheap-1',
        imageRefOriginDate: 'Aug. 10, 2014, 12:18 a.m.',
        timestamp: 1407629880,
        image: 'https://s3.amazonaws.com/kd4/austinheap',
        tokenId: '7413895387830281',
    },
    {
        nameDomain: 'i/boz-1',
        imageRefOriginDate: 'May 12, 2015, 1:50 a.m.',
        timestamp: 1431395400,
        image: 'https://s3.amazonaws.com/kd4/boz',
        tokenId: '3597390172434681',
    },
    {
        nameDomain: 'i/brennen-1',
        imageRefOriginDate: 'Aug. 2, 2014, 2:50 a.m.',
        timestamp: 1406947800,
        image: 'https://s3.amazonaws.com/kd4/brennen',
    },
    {
        nameDomain: 'i/cesckat-1',
        imageRefOriginDate: 'Dec. 30, 2014, 8:43 p.m.',
        timestamp: 1419972180,
        image: 'https://s3.amazonaws.com/kd4/cesckat',
    },
    {
        nameDomain: 'i/chrismatheson-1',
        imageRefOriginDate: 'May 12, 2015, 12:19 a.m.',
        timestamp: 1431389940,
        image: 'https://s3.amazonaws.com/kd4/chrismatheson',
    },
    {
        nameDomain: 'i/danbuchner-1',
        imageRefOriginDate: 'Aug. 21, 2015, 8:24 p.m.',
        timestamp: 1440188640,
        image: 'https://s3.amazonaws.com/kd4/danbuchner',
    },
    {
        nameDomain: 'i/danielmatthews-1',
        imageRefOriginDate: 'May 12, 2015, 6:13 a.m.',
        timestamp: 1431411180,
        image: 'https://s3.amazonaws.com/kd4/danielmatthews',
    },
    {
        nameDomain: 'i/darrancrowley-1',
        imageRefOriginDate: 'March 23, 2015, 4:41 p.m.',
        timestamp: 1427128860,
        image: 'https://s3.amazonaws.com/kd4/124ZfLnjqphnTWgiQ9pghwPqMZ5p56KoHe',
        tokenId: '26976514898948271',
    },
    {
        nameDomain: 'i/dm-1',
        imageRefOriginDate: 'Aug. 1, 2014, 8:53 a.m.',
        timestamp: 1406883180,
        image: 'https://s3.amazonaws.com/kd4/dm',
    },
    {
        nameDomain: 'i/el3k0n-1',
        imageRefOriginDate: 'March 10, 2014, 10:31 p.m.',
        timestamp: 1394490660,
        image: 'https://pbs.twimg.com/profile_images/1916219208/eightbit-d749378e-3a78-4aa5-93b1-6d6bb548995f.png',
        tokenId: '89174770224909021',
    },
    {
        nameDomain: 'i/garrickcheung-1',
        imageRefOriginDate: 'Sept. 3, 2014, 3:24 p.m.',
        timestamp: 1409757840,
        image: 'https://s3.amazonaws.com/kd4/garrickcheung',
    },
    {
        nameDomain: 'i/ksoderstrom-1',
        imageRefOriginDate: 'Dec. 2, 2014, 9:58 p.m.',
        timestamp: 1417557480,
        image: 'https://s3.amazonaws.com/kd4/ksoderstrom',
    },
    {
        nameDomain: 'i/mmacintyre-1',
        imageRefOriginDate: 'Nov. 17, 2014, 9:58 p.m.',
        timestamp: 1416261480,
        image: 'https://s3.amazonaws.com/kd4/mmacintyre',
    },
    {
        nameDomain: 'i/myles-1',
        imageRefOriginDate: 'March 10, 2014, 10:35 p.m.',
        timestamp: 1394490900,
        image: 'https://web.archive.org/web/20150914152852im_/http://static.mylesbraithwaite.com/img/avatars/hipster-square-350.png',
    },
    {
        nameDomain: 'i/myles-2',
        imageRefOriginDate: 'Aug. 31, 2015, 10:56 p.m.',
        timestamp: 1441061760,
        image: 'https://web.archive.org/web/20150914152852im_/http://static.mylesbraithwaite.com/img/avatars/hipster-square-350.png',
        tokenId: '7677499572363391',
    },
    {
        nameDomain: 'i/oujingwen-1',
        imageRefOriginDate: 'Jan. 4, 2015, 5:22 p.m.',
        timestamp: 1420392120,
        image: 'https://s3.amazonaws.com/kd4/oujingwen',
    },
    {
        nameDomain: 'i/samgreen-1',
        imageRefOriginDate: 'May 12, 2015, 2:29 a.m.',
        timestamp: 1431397740,
        image: 'https://s3.amazonaws.com/kd4/samgreen',
    },
    {
        nameDomain: 'i/tannerfilip-1',
        imageRefOriginDate: 'July 30, 2015, 1:40 a.m.',
        timestamp: 1438220400,
        image: 'https://s3.amazonaws.com/kd4/tannerfilip',
        tokenId: '21114224415090391',
    },
    {
        nameDomain: 'i/thefrow-1',
        imageRefOriginDate: 'May 6, 2014, 12:41 p.m.',
        timestamp: 1399380060,
        image: 'http://i.imgur.com/MiP2ULK.png',
    },
    {
        nameDomain: 'i/thefrow-2',
        imageRefOriginDate: 'June 11, 2014, 9 p.m.',
        timestamp: 1402520400,
        image: 'http://i.imgur.com/MiP2ULK.png',
    },
    {
        nameDomain: 'i/vijay-1',
        imageRefOriginDate: 'Oct. 28, 2014, 6:36 p.m.',
        timestamp: 1414521360,
        image: 'https://web.archive.org/web/20140727215606if_/https://pbs.twimg.com/profile_images/1770423339/vijay-eightbitme-large_400x400.png',
        tokenId: '25701674489067561',
    },
    {
        nameDomain: 'u/ajcorrado',
        imageRefOriginDate: 'Nov. 15, 2014, 9:34 p.m.',
        timestamp: 1416087240,
        image: 'https://s3.amazonaws.com/kd4/ajcorrado',
    },
    {
        nameDomain: 'u/alsotop',
        imageRefOriginDate: 'March 10, 2014, 10:31 p.m.',
        timestamp: 1394490660,
        image: 'http://www.gravatar.com/avatar/4ee0cf49a193fb365f87495757e6e1ad?rating=PG&size=240&default=mm',
    },
    {
        nameDomain: 'u/aoberoi',
        imageRefOriginDate: 'March 10, 2014, 10:35 p.m.',
        timestamp: 1394490900,
        image: 'https://web.archive.org/web/20141018100510im_/https://pbs.twimg.com/profile_images/1622129051/eightbit-69b2b73c-b8cb-4757-a660-39bafaf4bfc3_bigger.png',
        tokenId: '25710712718553231',
    },
    {
        nameDomain: 'u/crs',
        imageRefOriginDate: 'May 11, 2015, 11:11 p.m.',
        timestamp: 1431385860,
        image: 'https://s3.amazonaws.com/kd4/crs',
    },
    {
        nameDomain: 'u/dewet',
        imageRefOriginDate: 'Nov. 22, 2014, 2:57 p.m.',
        timestamp: 1416668220,
        image: 'https://s3.amazonaws.com/kd4/dewet',
        tokenId: '19042632727111131',
    },
    {
        nameDomain: 'u/docallag',
        imageRefOriginDate: 'Nov. 16, 2014, 1:55 a.m.',
        timestamp: 1416102900,
        image: 'https://s3.amazonaws.com/kd4/docallag',
    },
    {
        nameDomain: 'u/dreshfield',
        imageRefOriginDate: 'May 12, 2015, 7:40 a.m.',
        timestamp: 1431416400,
        image: 'https://s3.amazonaws.com/kd4/dreshfield',
    },
    {
        nameDomain: 'u/ducky',
        imageRefOriginDate: 'Nov. 14, 2014, 11:40 p.m.',
        timestamp: 1416008400,
        image: 'https://s3.amazonaws.com/kd4/ducky',
        tokenId: '51417334550169901',
    },
    {
        nameDomain: 'u/el3k0n',
        imageRefOriginDate: 'Nov. 21, 2014, 1:29 p.m.',
        timestamp: 1416576540,
        image: 'https://pbs.twimg.com/profile_images/1916219208/eightbit-d749378e-3a78-4aa5-93b1-6d6bb548995f.png',
        tokenId: '7461882148697651',
    },
    {
        nameDomain: 'u/eratron',
        imageRefOriginDate: 'May 3, 2014, 12:02 a.m.',
        timestamp: 1399075320,
        image: 'https://pbs.twimg.com/profile_images/437367799199956992/Mvro8rrp_400x400.png',
    },
    {
        nameDomain: 'u/gerbz',
        imageRefOriginDate: 'Nov. 16, 2014, 5:38 a.m.',
        timestamp: 1416116280,
        image: 'https://s3.amazonaws.com/kd4/gerbz',
    },
    {
        nameDomain: 'u/giulio893',
        imageRefOriginDate: 'May 12, 2015, 5:17 p.m.',
        timestamp: 1431451020,
        image: 'https://s3.amazonaws.com/kd4/giulio893',
    },
    {
        nameDomain: 'u/hughlang',
        imageRefOriginDate: 'March 11, 2014, 1:20 a.m.',
        timestamp: 1394500800,
        image: 'https://pbs.twimg.com/profile_images/1281603287/eightbit-6fd09ea9-cc42-4f32-8668-d08d1e276781.png',
    },
    {
        nameDomain: 'u/johnmurphy',
        imageRefOriginDate: 'Nov. 15, 2014, 3:44 p.m.',
        timestamp: 1416066240,
        image: 'https://s3.amazonaws.com/kd4/johnmurphy',
    },
    {
        nameDomain: 'u/katieb',
        imageRefOriginDate: 'Nov. 17, 2014, 8:12 p.m.',
        timestamp: 1416255120,
        image: 'https://s3.amazonaws.com/kd4/katieb',
    },
    {
        nameDomain: 'u/michaelrubio',
        imageRefOriginDate: 'Aug. 22, 2014, 10:06 p.m.',
        timestamp: 1408745160,
        image: 'https://s3.amazonaws.com/kd4/michaelrubio',
    },
    {
        nameDomain: 'u/obi',
        imageRefOriginDate: 'Dec. 10, 2014, 3:04 p.m.',
        timestamp: 1418223840,
        image: 'https://s3.amazonaws.com/kd4/obi',
    },
    {
        nameDomain: 'u/poon',
        imageRefOriginDate: 'July 25, 2014, 9:09 p.m.',
        timestamp: 1406322540,
        image: 'https://pbs.twimg.com/profile_images/1255519882/8bit_avatar.jpg',
    },
    {
        nameDomain: 'u/tim',
        imageRefOriginDate: 'Dec. 11, 2014, 4:25 a.m.',
        timestamp: 1418271900,
        image: 'https://s3.amazonaws.com/kd4/tim',
    },
    {
        nameDomain: 'u/vijay',
        imageRefOriginDate: 'March 13, 2014, 3:48 p.m.',
        timestamp: 1394725680,
        image: 'https://web.archive.org/web/20140727215606if_/https://pbs.twimg.com/profile_images/1770423339/vijay-eightbitme-large_400x400.png',
    },
    {
        nameDomain: 'u/vnz',
        imageRefOriginDate: 'May 21, 2014, 1:58 p.m.',
        timestamp: 1400680680,
        image: 'https://pbs.twimg.com/profile_images/1671148564/eightbit-3a99911e-a537-4dbc-a84f-06d387a3283d.png',
        tokenId: '4770824728579841',
    },
];
const singleBlockheads = [
    'i/austinheap-1',
    'i/boz-1',
    'i/brennen-1',
    'i/cesckat-1',
    'i/chrismatheson-1',
    'i/danbuchner-1',
    'i/danielmatthews-1',
    'i/darrancrowley-1',
    'i/dm-1',
    'i/garrickcheung-1',
    'i/ksoderstrom-1',
    'i/mmacintyre-1',
    'i/oujingwen-1',
    'i/samgreen-1',
    'i/tannerfilip-1',
    'u/ajcorrado',
    'u/alsotop',
    'u/aoberoi',
    'u/crs',
    'u/dewet',
    'u/docallag',
    'u/dreshfield',
    'u/ducky',
    'u/eratron',
    'u/gerbz',
    'u/giulio893',
    'u/hughlang',
    'u/johnmurphy',
    'u/katieb',
    'u/michaelrubio',
    'u/obi',
    'u/poon',
    'u/tim',
    'u/vnz',
];
const duplicateBlockheads = [
    'i/el3k0n-1',
    'i/myles-1',
    'i/myles-2',
    'i/thefrow-1',
    'i/thefrow-2',
    'i/vijay-1',
    'u/el3k0n',
    'u/vijay',
];

function App() {

    const [selectedBlockhead, setSelectedBlockhead] = React.useState({})
    const [blockheads, setBlockheads] = React.useState([]);
    const [sortBy, setSortBy] = React.useState('');
    const [countFilter, setCountFilter] = React.useState('');
    const [yearFilter, setYearFilter] = React.useState('');
    const [saleFilter, setSaleFilter] = React.useState('');

    React.useEffect(() => {
        axios
            .get('https://api.opensea.io/api/v1/assets?token_ids=19042632727111131&token_ids=7413895387830281&token_ids=3597390172434681&token_ids=26976514898948271&token_ids=89174770224909021&token_ids=7677499572363391&token_ids=21114224415090391&token_ids=25701674489067561&token_ids=25710712718553231&token_ids=51417334550169901&token_ids=7461882148697651&token_ids=4770824728579841&asset_contract_address=0x82c7a8f707110f5fbb16184a5933e9f78a34c6ab&order_direction=desc&offset=0&limit=50')
            .then(res => {
                const OSblockheads = blockheadData.map(head => {
                    let updatedHead = head
                    if(head.tokenId){
                        const osToken = res.data.assets.find(asset => asset.token_id === head.tokenId)
                        updatedHead.attributes = osToken
                    }
                    return updatedHead
                })
                setBlockheads([...OSblockheads])
            })
            .catch(err => {
                setBlockheads([...blockheadData])
                console.log(err.message)
            })
    }, [])

    const onSortChange = (selectedType, data, sortingValue) => {
        if(selectedType === 'sort' && sortBy !== sortingValue) setSortBy(sortingValue || '')
        if(sortingValue === 'name') return data.sort((a,b) => {
                if (a.nameDomain < b.nameDomain) return -1;
                if (a.nameDomain > b.nameDomain) return 1;
                return 0;
            });
        else if(sortingValue === 'originDate') return data.sort((a,b) => {
                if (a.timestamp < b.timestamp) return -1;
                if (a.timestamp > b.timestamp) return 1;
                return 0;
            });
        else if(sortingValue === 'priceLtoH') {
            return data.sort((a,b) => {
                const aIsListed = a.attributes && a.attributes.sell_orders && a.attributes.sell_orders[0] && a.attributes.sell_orders[0].base_price
                const bIsListed = b.attributes && b.attributes.sell_orders && b.attributes.sell_orders[0] && b.attributes.sell_orders[0].base_price
                if (aIsListed && !bIsListed) return -1;
                if (!aIsListed && bIsListed) return 1;
                if (aIsListed && bIsListed && (a.attributes.sell_orders[0].base_price - b.attributes.sell_orders[0].base_price) < 0) return -1;
                if (aIsListed && bIsListed && (a.attributes.sell_orders[0].base_price - b.attributes.sell_orders[0].base_price) > 0) return 1;
                return 0;
            });
        }
        else if(sortingValue === 'priceHtoL') {
            return data.sort((a,b) => {
                const aIsListed = a.attributes && a.attributes.sell_orders && a.attributes.sell_orders[0] && a.attributes.sell_orders[0].base_price
                const bIsListed = b.attributes && b.attributes.sell_orders && b.attributes.sell_orders[0] && b.attributes.sell_orders[0].base_price
                if (aIsListed && !bIsListed) return -1;
                if (!aIsListed && bIsListed) return 1;
                if (aIsListed && bIsListed && (a.attributes.sell_orders[0].base_price - b.attributes.sell_orders[0].base_price > 0)) return -1;
                if (aIsListed && bIsListed && (a.attributes.sell_orders[0].base_price - b.attributes.sell_orders[0].base_price) < 0) return 1;
                return 0;
            });
        }
        else return data.sort((a,b) => {
                if (a.nameDomain < b.nameDomain) return -1;
                if (a.nameDomain > b.nameDomain) return 1;
                return 0;
            });
    };

    const onYearFilterChange = (selectedType, data, selectedYear) => {
        if(selectedType === 'year' && yearFilter !== selectedYear) setYearFilter(selectedYear || '')
        if(selectedYear === '2014') return data.filter(head => head.timestamp > 1388534400 && head.timestamp < 1420027199)
        else if(selectedYear === '2015') return data.filter(head => head.timestamp > 1420070401 && head.timestamp < 1451563199)
        else return data
    }

    const onCountFilterChange = (selectedType, data, selectedCount) => {
        if(selectedType === 'count' && countFilter !== selectedCount) setCountFilter(selectedCount || '')
        if(selectedCount === 'duplicate') return data.filter(head => duplicateBlockheads.includes(head.nameDomain))
        else if(selectedCount === 'unique') return data.filter(head => singleBlockheads.includes(head.nameDomain))
        else return data
    }

    const onSaleFilterChange = (selectedType, data, selectedSale) => {
        if(selectedType === 'sale' && saleFilter !== selectedSale) setSaleFilter(selectedSale || '')
        if(selectedSale === 'buyNow') return data.filter(head => head.attributes && head.attributes.sell_orders && head.attributes.sell_orders[0] && head.attributes.sell_orders[0].base_price)
        else if(selectedSale === 'unlisted') return data.filter(head => !(head.attributes && head.attributes.sell_orders && head.attributes.sell_orders[0] && head.attributes.sell_orders[0].base_price))
        else return data
    }

    const masterControl = (e, handler) => {
        const sortType = sortBy
        const yearType = yearFilter
        const countType = countFilter
        const saleType = saleFilter
        let heads = blockheadData
        const selectedChange = e.target.value
        const selectedType = e.target.name
        if(handler === 'onSort'){
            heads = onCountFilterChange(selectedType, heads, countType)
            heads = onYearFilterChange(selectedType, heads, yearType)
            heads = onSaleFilterChange(selectedType, heads, saleType)
            heads = onSortChange(selectedType, heads, selectedChange)
            setBlockheads(heads)
        }
        if(handler === 'onYear'){
            heads = onSortChange(selectedType, heads, sortType)
            heads = onCountFilterChange(selectedType, heads, countType)
            heads = onSaleFilterChange(selectedType, heads, saleType)
            heads = onYearFilterChange(selectedType, heads, selectedChange)
            setBlockheads(heads)
        }
        if(handler === 'onCount'){
            heads = onSortChange(selectedType, heads, sortType)
            heads = onYearFilterChange(selectedType, heads, yearType)
            heads = onSaleFilterChange(selectedType, heads, saleType)
            heads = onCountFilterChange(selectedType, heads, selectedChange)
            setBlockheads(heads)
        }
        if(handler === 'onSale'){
            heads = onSortChange(selectedType, heads, sortType)
            heads = onYearFilterChange(selectedType, heads, yearType)
            heads = onCountFilterChange(selectedType, heads, countType)
            heads = onSaleFilterChange(selectedType, heads, selectedChange)
            setBlockheads(heads)
        }
    }

    const renderModal = (blockhead) => {
        return (
            <>
                {blockhead.attributes ? (
                    <>
                        <Button
                            onClick={() => setSelectedBlockhead(blockhead)
                            }
                            loadingText="Loading"
                            colorScheme="darkslategray"
                            variant="outline"
                            spinnerPlacement="start"
                            size="lg"
                        >
                            View Details
                        </Button>
                        <Modal show={selectedBlockhead.nameDomain === blockhead.nameDomain} onHide={() => setSelectedBlockhead({})} centered size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title>{blockhead.nameDomain} - {blockhead.attributes.name}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="baseClassEvenSpread" style={{ margin: '15px' }}>
                                    <div style={{ width: '284px', marginLeft: '3%', marginBottom: '20px'}}>
                                        <img className="blockheadImage" src={blockhead.image} alt={blockhead.nameDomain} height="200px" width="200px"/>
                                        <h5 style={{fontSize: '13px'}}>{blockhead.attributes.description}</h5>
                                    </div>
                                    <div style={{ fontSize: '11px', width: '370px', marginLeft: '3%'}}>
                                        {blockhead.attributes.traits.map(trait => (
                                            <div style={{ borderBottom: '1px solid gray', padding: '5px 0'}}>
                                                <span>{trait.trait_type}: {trait.value}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                </Modal.Body>
                            <Modal.Footer>
                            <Button
                                colorScheme="darkslategray"
                                variant="outline"
                                size="lg"
                                onClick={() => setSelectedBlockhead({})}
                            >
                                Close
                            </Button>
                            </Modal.Footer>
                        </Modal>
                    </>
                ): <div style={{ height: '48px'}}/>}
            </>
        )
    }

    return (
        <div className="App App-header">
        <h1>The Blockhead Collection</h1>
        <div style={{ width: '20%', borderBottom: '1px solid white', paddingBottom: '25px', marginBottom: '10px'}}/>
        <div className="topMenu">
            <div className="baseClassCenter">
                <a className="link" rel="noreferrer" href="https://opensea.io/collection/emblem-vault?search[query]=Blockhead&search[sortAscending]=true&search[sortBy]=PRICE" target="_blank">
                    <img alt="OpenSea logo" src={OSLogo} height="50px" width="50px" />
                </a>
                <a className="link" rel="noreferrer" href="https://twitter.com/eggs_namecoin?s=21" target="_blank">
                    <img alt="Twitter logo" src={TwitterLogo} height="50px" width="50px" />
                </a>
            </div>
        </div>
        <div style={{ width: '100%' }}>
            <div className="baseClassEvenSpread">
                <div className="baseClass filterRow headerSpacing">
                    <div className="span"><span>Sort by:</span></div>
                    <div className="selectContainer">
                        <Select name="sort" defaultValue={sortBy || null} size="lg" placeholder="Select..." onChange={(e) => masterControl(e, 'onSort')}>
                            <option value="name">Name</option>
                            <option value="originDate">Origin Date</option>
                            <option value="priceLtoH">Price Low to High</option>
                            <option value="priceHtoL">Price High to Low</option>
                        </Select>
                    </div>
                </div>
                <div className="baseClass filterRow headerSpacing">
                    <div className="span"><span>Year Filter:</span></div>
                    <div className="selectContainer">
                        <Select name="year" defaultValue={yearFilter || null} size="lg" placeholder="Select..." onChange={(e) => masterControl(e, 'onYear')}>
                            <option value="2014">2014</option>
                            <option value="2015">2015</option>
                        </Select>
                    </div>
                </div>
            </div>
            <div className="baseClassEvenSpread">
                <div className="baseClass filterRow headerSpacing">
                    <div className="span"><span>Count Filter:</span></div>
                    <div className="selectContainer">
                        <Select name="count" defaultValue={countFilter || null} size="lg" placeholder="Select..." onChange={(e) => masterControl(e, 'onCount')}>
                            <option value="unique">Unique</option>
                            <option value="duplicate">Duplicate</option>
                        </Select>
                    </div>
                </div>
                <div className="baseClass filterRow headerSpacing">
                <div className="span"><span>Available:</span></div>
                <div className="selectContainer">
                    <Select name="sale" defaultValue={saleFilter || null} size="lg" placeholder="Select..." onChange={(e) => masterControl(e, 'onSale')}>
                        <option value="buyNow">Buy Now</option>
                        <option value="unlisted">Unlisted</option>
                    </Select>
                </div>
            </div>
            </div>
        </div>
        <div className="baseClassCenter bodySpacing">
            {blockheads.length > 0 && blockheads.map(blockhead => (
                <div className="baseClassCenter blockheadCard" key={blockhead.nameDomain}>
                    <img className="blockheadImage" src={blockhead.image} alt={blockhead.nameDomain} height="200px" width="200px"/>
                    <h2>Name: {blockhead.nameDomain}</h2>
                    <h3>Origin Date: {blockhead.imageRefOriginDate}</h3>
                    <div style={{ width: '80%', borderBottom: '1px solid white', margin: '10px 0 15px 0'}}/>
                    <div className="baseClassCenter">
                        {blockhead.attributes && blockhead.attributes.sell_orders ? (
                            <>
                                <div className="baseClassCenter">
                                    <a style={{ marginRight: '10px'}} rel="noreferrer" href={blockhead.attributes.permalink} target="_blank">
                                        <img alt="OpenSea logo" src={OSLogo} height="20px" width="20px" />
                                    </a>
                                    <h4>Listing Price: {ethers.utils.formatEther(blockhead.attributes.sell_orders[0].base_price)}Ξ</h4>
                                </div>
                            </>
                        ) : <div style={{ height: '20px'}}/>}
                    </div>
                    <div className="baseClassCenter bodySpacing">
                        {renderModal(blockhead)}
                    </div>
                </div>
            ))}
        </div>
        <div className="baseClassCenter footer">
            <span className="footerText">If this Blockhead gallery was valuable to you, feel free to make donations to the devs so we can continue improving functionality.</span>
            <span className="footerText">ETH Address: 0x3eb2C4D81f2f077a0a57322f3c1f142108e84583</span>
        </div>
    </div>
    );
}

export default App;